import React, { Fragment, FunctionComponent } from 'react';
import "../error.scss"
import Text from '../../../components/typography/typgraphy';

const InvalidPanMismatchCBS: FunctionComponent = () => {
  return (
    <Fragment>
      <Text className="error-description"> PAN Number Invalid / PAN Number Mismatch</Text>
    </Fragment>
  )
}

export default InvalidPanMismatchCBS;